function initGallerySliders() {
  var galleryImages = document.querySelectorAll('.blocks__gallery');

  galleryImages.forEach(function(gallery) {
    var imageContainer = gallery.querySelector('.blocks__gallery ul');
    var leftArrow = gallery.querySelector('.blocks__gallery__arrow--left');
    var rightArrow = gallery.querySelector('.blocks__gallery__arrow--right');
    var images = imageContainer.querySelectorAll('li');
    var scrollEndTimeout;
    var scrollOffset = parseFloat(getComputedStyle(document.documentElement).fontSize); // 1rem in px

    function setActiveImage(nextActiveImage) {
      if (!nextActiveImage) return;

      images.forEach(function(image) {
        image.classList.remove('active');
      });

      nextActiveImage.classList.add('active');
      updateArrows();
    }

    function getClosestImageToScrollPosition() {
      if (!images.length) return null;

      var currentScrollLeft = imageContainer.scrollLeft;
      var closestImage = images[0];
      var smallestDistance = Math.abs(images[0].offsetLeft - currentScrollLeft);

      images.forEach(function(image) {
        var distance = Math.abs(image.offsetLeft - currentScrollLeft);
        if (distance < smallestDistance) {
          smallestDistance = distance;
          closestImage = image;
        }
      });

      return closestImage;
    }

    function syncActiveSlideToScroll() {
      setActiveImage(getClosestImageToScrollPosition());
    }

    function updateArrows() {
      var activeIndex = Array.from(images).findIndex(li => li.classList.contains('active'));
      var isFirst = activeIndex === 0;
      var isLast = activeIndex === images.length - 1;

      leftArrow.classList.toggle('disabled', isFirst);
      rightArrow.classList.toggle('disabled', isLast);

      leftArrow.style.opacity = isFirst ? '0.35' : '1';
      rightArrow.style.opacity = isLast ? '0.35' : '1';
      leftArrow.style.pointerEvents = isFirst ? 'none' : 'auto';
      rightArrow.style.pointerEvents = isLast ? 'none' : 'auto';
    }

    rightArrow.addEventListener('click', function() {
      var currentImage = imageContainer.querySelector('li.active');
      var nextImage = currentImage.nextElementSibling;
      if (nextImage) {
        var nextImagePosition = Math.max(0, nextImage.offsetLeft - scrollOffset);
        imageContainer.scrollTo({ left: nextImagePosition, behavior: 'smooth' });
        setActiveImage(nextImage);
      }
    });

    leftArrow.addEventListener('click', function() {
      var currentImage = imageContainer.querySelector('li.active');
      var prevImage = currentImage.previousElementSibling;
      if (prevImage) {
        var prevImagePosition = Math.max(0, prevImage.offsetLeft - scrollOffset);
        imageContainer.scrollTo({ left: prevImagePosition, behavior: 'smooth' });
        setActiveImage(prevImage);
      }
    });

    if ('onscrollend' in window) {
      imageContainer.addEventListener('scrollend', syncActiveSlideToScroll);
    } else {
      imageContainer.addEventListener('scroll', function() {
        clearTimeout(scrollEndTimeout);
        scrollEndTimeout = setTimeout(syncActiveSlideToScroll, 120);
      });
    }

    // Initialize: set first image active if none, and update arrows
    if (!imageContainer.querySelector('li.active') && images.length) {
      images[0].classList.add('active');
    }
    updateArrows();
  });
}

// Usage: call initGallerySliders() after your fetch completes and DOM is updated
initGallerySliders();